module.exports = __webpack_public_path__ + "img/july-2019.d0e50176.png";